import { useEffect, useState } from 'react';
import { assetQuery, sanityFetch } from '../services/sanity';
import { agencyQuery } from './agencies';
import { astronautQuery } from './astronauts';
import { craftQuery } from './crafts';
import { nationQuery } from './nations';
// ---------- FUNCTIONS ----------
export const getMission = async (config, id) => {
    return sanityFetch(config, `*[
    _type == 'mission'
    && _id == '${id}'
  ][0]${missionQuery}`);
};
export const getMissions = async (config) => {
    return sanityFetch(config, `*[
    _type == 'mission'
    && !(_id in path("drafts.**"))
  ]${missionQuery}`);
};
export const getMissionBySlug = async (config, slug) => {
    return sanityFetch(config, `*[
    _type == 'mission'
    && slug.current == '${slug}'
  ][0]${missionQuery}`);
};
export const useMission = (config, slug, _mission, isFocused = true) => {
    const [mission, setMission] = useState(_mission);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!slug) {
            return;
        }
        if (!mission) {
            setLoading(true);
            getMissionBySlug(config, slug).then((v) => {
                setMission(v);
                setLoading(false);
            });
        }
    }, [isFocused, slug]);
    return { mission, loading };
};
// ---------- QUERIES ----------
export const missionQuery = `{
  _id,
  slug,
  name,
  seriesName,
  seriesNumber,
  shortDescription,
  vagueLaunchDate,
  launchDate,
  landDate,
  image ${assetQuery},
  astronauts[]->${astronautQuery},
  landingCrew[]->${astronautQuery},
  animalCrew[]->${astronautQuery},
  spacecrafts[]->${craftQuery},
  nations[]->${nationQuery},
  agencies[]->${agencyQuery}
}`;
//# sourceMappingURL=missions.js.map